import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Stock module.
 * The Stock module guards accept either moduleId 28 (stock) or 29 (sales matrix);
 * we use 28 here as the canonical menu-admin grouping value.
 */
export const STOCK_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/stock/overview',
    labelKey: 'Stock.overview',
    icon: '/assets/tablerIcons/outline/package.svg',
    moduleId: 28,
    groupLabelKey: 'MenuRoutes.group.stockViews'
  },
  {
    path: '/stock/goods',
    labelKey: 'Stock.goods',
    icon: '/assets/tablerIcons/outline/box.svg',
    moduleId: 28,
    groupLabelKey: 'MenuRoutes.group.stockViews'
  },
  {
    path: '/stock/products',
    labelKey: 'Stock.products',
    icon: '/assets/tablerIcons/outline/barcode.svg',
    moduleId: 28,
    groupLabelKey: 'MenuRoutes.group.stockViews'
  },
  {
    path: '/stock/import',
    labelKey: 'Stock.import',
    icon: '/assets/tablerIcons/outline/file-import.svg',
    moduleId: 28,
    groupLabelKey: 'MenuRoutes.group.stockTools'
  },
  {
    path: '/stock/sales-matrix',
    labelKey: 'Stock.salesMatrix',
    icon: '/assets/tablerIcons/outline/table.svg',
    // moduleId 28 (not 29) is the canonical menu-admin grouping value — keeps all Stock
    // routes under one picker group header. The route guard accepts [28, 29] regardless.
    moduleId: 28,
    groupLabelKey: 'MenuRoutes.group.stockTools'
  }
];
